module.exports = __webpack_public_path__ + "img/call-ended.74ef3bd1.svg";